var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-wrap"},[_vm._l((_vm.mopList),function(m,index){return [_c('mop-item',{key:index,attrs:{"mop":m},on:{"edit":() =>
          _vm.$router.push({
            name: 'MainModeForm',
            params: { mopId: m.mopId, mode: 'edit' },
          }),"delete":function($event){return _vm.deactivate(m)},"toggleStatus":function($event){return _vm.toggleStatus(m)}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }